import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('nav.privacy'), href: '/privacy' },
  ];

  return (
    <footer className="bg-gradient-to-br from-sky-700 to-sky-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo */}
          <div className="font-heading font-black text-3xl mb-6">
            <span className="text-sky-200">RUI</span> <span>2027</span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            {footerLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-white/80 hover:text-sky-200 transition-colors text-sm uppercase tracking-wider"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Divider */}
          <div className="border-t border-white/10 pt-8">
            <p className="text-white/60 text-sm mb-4">
              &copy; {new Date().getFullYear()} {t('footer.rights')}.
            </p>
            {/* <div className="inline-block bg-white/10 px-4 py-2 rounded text-xs text-white/60 max-w-lg">
              {t('footer.paidFor')}
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
